import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { persistUtmParams, trackAnalyticsEvent } from '@/lib/analytics';

const PAGEVIEW_DEBOUNCE_MS = 150;

export const useAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    persistUtmParams(window.location.search);
  }, []);

  useEffect(() => {
    const timeout: number | undefined = window.setTimeout(() => {
      trackAnalyticsEvent('page_view', { path: location.pathname });
      persistUtmParams(location.search);
    }, PAGEVIEW_DEBOUNCE_MS);

    return () => {
      if (timeout) {
        window.clearTimeout(timeout);
      }
    };
  }, [location.pathname, location.search]);
};

export default useAnalytics;

